"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowEnvironmentLoaderInitializer = exports.WindowEnvironmentInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const environmentVariablesManager_1 = require("./environmentVariablesManager");
const WINDOW_ENVIRONMENT__ERROR = 'Window environment initialization error';
class WindowEnvironmentInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(WINDOW_ENVIRONMENT__ERROR, message);
    }
}
exports.WindowEnvironmentInitializationError = WindowEnvironmentInitializationError;
class WindowEnvironmentLoaderInitializer extends web_ui_framework_1.Initializer {
    constructor() {
        super(...arguments);
        this.launch = () => {
            try {
                return new environmentVariablesManager_1.EnviromentVariablesManager();
            }
            catch (e) {
                throw new WindowEnvironmentInitializationError(e);
            }
        };
    }
}
exports.WindowEnvironmentLoaderInitializer = WindowEnvironmentLoaderInitializer;
//# sourceMappingURL=environmentVariablesManager.initializer.js.map